export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-480-7bd81e1b4cd5da32bd5d7dc76c733d65.png";